(function () {
  function setup(section) {
    if (!('IntersectionObserver' in window)) return;
    if (section.classList.contains('tc-anim')) return; // avoid double init
    section.classList.add('tc-anim');

    // Trigger A — heading + subtitle + review cards (staggered)
    var head = section.querySelector('.testimonials-custom__header') || section;
    var obsHead = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.add('tc-reveal-head');
            obsHead.disconnect();
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );
    obsHead.observe(head);

    // Trigger B — numbering + arrows (fires a bit lower on scroll)
    var controls = section.querySelector('.fpt-controls');
    if (controls) {
      var obsCtrl = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              section.classList.add('tc-reveal-ctrl');
              obsCtrl.disconnect();
            }
          });
        },
        { threshold: 0, rootMargin: '0px 0px -8% 0px' }
      );
      obsCtrl.observe(controls);
    } else {
      section.classList.add('tc-reveal-ctrl');
    }
  }

  function initAll() {
    document.querySelectorAll('.testimonials-custom').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.testimonials-custom');
    if (section) setup(section);
  });
})();
